module.exports = __webpack_public_path__ + "img/price-3.7148e092.jpg";